import { createFileRoute } from '@tanstack/react-router';
import { CleanerRegistrationTerms } from '@/features/cleaner/registrations/cleaner-terms';

export const Route = createFileRoute(
  '/(cleaner)/_registration/cleaner/signup-terms'
)({
  component: CleanerRegistrationTerms,
});
